<template>
    <v-footer
      inset
      relative 
      dark
      padless
      width="auto"
      color="#525355"
      height="auto"
    >
    <v-layout column>
      <v-flex xs12 style="background-color: #193705;">
        
          <v-container class="my-1">
            <v-layout row wrap class="my-4">
              <v-flex xs12 md3>
                <div class="mx-3 mt-5 d-flex justify-center align-center flex-column">
                  <a @click="goToHome()">
        <v-img max-width="210" max-height="64" contain class="mt-2  mb-3 hidden-sm-and-down" src="img/aatf_logo.png">
        </v-img>
      </a>
      <a @click="goToHome()">
        <v-img max-width="180" max-height="100" class="mt-2 mb-3 hidden-md-and-up" src="img/aatf_logo.png">
        </v-img>
      </a>
                 </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="mx-3 mt-5">
                  <div class="font-weight-black my-5 white--text">{{ $t("aboutUsMsg") }}</div>
                  <a class="white--text caption" href="/#/" style="text-decoration: none">{{ $t("homeMessage") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="white--text caption" href="https://www.aatf-africa.org/about-us/" target="_blank" style="text-decoration: none">{{ $t("aboutMsg") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="white--text caption" href="/#/faqs" style="text-decoration: none">{{ $t("faqsInFullMessage") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="mx-3 mt-5">
                  <div class="font-weight-black my-5 white--text">{{ $t("quickLinksMessage") }}</div>
                  <a class="white--text caption mt-5" href="/#/projects" style="text-decoration: none">{{ $t("projectsMessage") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="white--text caption" href="/#/publications" style="text-decoration: none">{{ $t("publicationMessage") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="white--text caption" href="/#/media" style="text-decoration: none">{{ $t("mediaMessage") }}</a>
                  <v-divider class="my-2 white--text"></v-divider>
                </div>
              </v-flex>
              <!-- <v-flex xs12 md3>
                <div class="mx-3 mt-5">
                  <div class="font-weight-black  my-5 white--text" >MEDIA</div>
                  <a class="white--text caption mt-5" href="/#/news-feed" style="text-decoration: none">News Feed</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="white--text caption" href="/#/stories" style="text-decoration: none">Stories</a>
                  <v-divider class="my-2 white--text"></v-divider>
                  <a class="caption white--text" href="/#/gallery" style="text-decoration: none">Gallery</a>
                  <v-divider class="my-2 white--text"></v-divider>
                </div>
              </v-flex> -->
            </v-layout>
          </v-container>
      </v-flex>
        <v-flex xs12 style="background-color: #193705;">
          <v-divider class="white--text"></v-divider>
            <v-container class="my-5">
              <v-layout row wrap>
                  <v-flex xs12 md4>
                    <a align="left" class="caption white--text hidden-sm-and-down" href="/#/terms-and-conditions" style="text-decoration: none;">{{ $t("termsAndConditionsMsg") }}</a>
                  </v-flex>
                  <v-flex xs12 md4 class="d-flex align-center justify-center">
                    <v-flex xs12 md3>
                <div>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="d-flex flex-row">
                        <template >
                          <a
                            target="_blank"
                            href="https://www.facebook.com/aatfafrica/"
                            style="text-decoration: none"
                          >
                            <v-btn class="mx-2" icon>
                              <v-icon size="25px" color="white"> mdi-facebook </v-icon>
                            </v-btn>
                          </a>
                          <a
                            target="_blank"
                            href="https://x.com/aatfafrica"
                            style="text-decoration: none"
                          >
                            <v-btn class="mx-2" icon>
                              <!-- <v-icon size="25px" color="white"> mdi-twitter </v-icon> -->
                              <img src="img/twitterX_logo_white.png" alt="twitter" style="width: 22px; height: 22px;"/>
                            </v-btn>
                          </a>
                          <a
                            target="_blank"
                            href="https://www.youtube.com/@AATFAfrica"
                            style="text-decoration: none"
                          >
                            <v-btn class="mx-2" icon>
                              <v-icon size="25px" color="white"> mdi-youtube </v-icon>
                            </v-btn>
                          </a>
                          <a
                            target="_blank"
                            href="https://www.instagram.com/aatfafrica/"
                            style="text-decoration: none"
                          >
                            <v-btn class="mx-2" icon>
                              <v-icon size="25px" color="white"> mdi-instagram </v-icon>
                            </v-btn>
                          </a>
                        </template>
                      </div>                      
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
                  </v-flex>
                  <v-flex xs12 md4>
                  <div align="right" class="caption white--text hidden-sm-and-down">
                      © {{ new Date().getFullYear() }} • {{ $t("allRightsReservedMsg") }}
                  </div>
                  </v-flex>
              </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
    
          
    </v-footer>
  </template>
  <script>
    export default {
      data: () => ({
        socials: [

        ],
      }),
    }
  </script>
